import { all, call, put, takeLatest } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import formatSinglePlural from 'utils/formatSinglePlural';
import { LOCATION_CHANGE } from 'react-router-redux';

import { UPDATE_ORDER_LINES_SUCCESS } from 'redux/modules/ordersLines';
import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const FETCH_CONNECTED_ORDERS = 'FETCH_CONNECTED_ORDERS';
export const FETCH_CONNECTED_ORDERS_SUCCESS = 'FETCH_CONNECTED_ORDERS_SUCCESS';
export const FETCH_CONNECTED_ORDERS_FAIL = 'FETCH_CONNECTED_ORDERS_FAIL';
export const CLEAR_CONNECTED_ORDERS = 'CLEAR_CONNECTED_ORDERS';

// Reducer
export default function connectedOrdersReducer(
  state = { data: [], count: 0, orderLineID: [], orderID: null, loading: 0 },
  action,
) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_CONNECTED_ORDERS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_CONNECTED_ORDERS_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_CONNECTED_ORDERS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_CONNECTED_ORDERS:
      return {
        ...state,
        data: [],
        count: 0,
        orderLineID: [],
        orderID: null,
      };
    case UPDATE_ORDER_LINES_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        const newDataItem = payload.data[dataItem.ID];
        if (newDataItem) {
          return newDataItem;
        }

        return dataItem;
      });
      return {
        ...state,
        data: newData,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchConnectedOrders(payload) {
  return { type: FETCH_CONNECTED_ORDERS, payload };
}

export function fetchConnectedOrdersSuccess(payload) {
  return { type: FETCH_CONNECTED_ORDERS_SUCCESS, payload };
}

export function fetchConnectedOrdersFail(payload) {
  return { type: FETCH_CONNECTED_ORDERS_FAIL, payload };
}

export function clearConnectedOrders() {
  return { type: CLEAR_CONNECTED_ORDERS };
}

// Requests
export function requestFetchConnectedOrders(payload) {
  return callApi('workflow/order_info/search/', 'POST', {
    'Info Type': 'Linked Order Refill',
    'Order Line ID': payload,
  });
}

// Sagas
function* fetchConnectedOrdersSaga(action) {
  const { triggerLoading, orderLineID, orderID } = action.payload;
  try {
    const res = yield all(
      orderLineID.map(item => call(requestFetchConnectedOrders, item)),
    );
    const mergedRes = res
      .map(item => item.data)
      .reduce((accumulator, currentValue) => ([
        ...accumulator,
        ...currentValue,
      ]))
      .filter((element, index, array) =>
        array.findIndex(item => item.ID === element.ID) === index,
      );
    yield put(fetchConnectedOrdersSuccess({
      orderLineID,
      ...orderID ? { orderID } : {},
      data: mergedRes,
      count: mergedRes.length,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res[0].user_info));
    yield put(fetchAppInfoSuccess(res[0].app_info));
    if (orderID) {
      yield put(addNotification({
        message: `Order ${orderID} is connected with
          ${mergedRes.length} other
          ${formatSinglePlural({ quantity: mergedRes.length, single: 'order', plural: 'orders' })}`,
        variant: 'info',
        actionHref: `/workflow/connected-orders/${orderLineID.join(',')}`,
        actionText: 'View',
      }));
    }
  } catch (err) {
    yield put(fetchConnectedOrdersFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

export function* connectedOrdersSaga() {
  yield takeLatest(FETCH_CONNECTED_ORDERS, fetchConnectedOrdersSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/connectedOrders.js